import React from 'react';
import { PRICE } from '../data/offer';
import { Reveal } from './Reveal';
import { AlertIcon, ArrowRightIcon, PdfIcon } from './icons/CraftIcons';
const receipt = [{
  id: 'r1',
  label: 'Pattern #1 — "Chunky Tote"',
  amount: 10
}, {
  id: 'r2',
  label: 'Pattern #2 — "Baby Blanket"',
  amount: 9
}, {
  id: 'r3',
  label: 'Pattern #3 — "Bucket Hat"',
  amount: 8
}];
export function BrutalTruth() {
  const spent = receipt.reduce((sum, row) => sum + row.amount, 0);
  return <section aria-labelledby="brutal-truth" className="w-full border-y border-hairline bg-ivory px-4 py-10 sm:px-6 sm:py-14 lg:py-20" data-id="element-17" data-mp="2hbrtj4fl54ot">
      <div className="mx-auto grid max-w-[1120px] items-center gap-7 sm:gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-18" data-mp="2qbeu5o0hq6gt">
        <Reveal data-id="element-19" data-mp="2v8oewqcxptyb">
          <span className="inline-flex items-center gap-2 rounded-full border border-crimson/25 bg-crimson-tint px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-crimson" data-id="element-20" data-mp="2v8ex3q21mt3p">
            <AlertIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="10vfctjmpxaq3" />
            Section 1 — The brutal truth
          </span>
          <h2 id="brutal-truth" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-22" data-mp="2ldmkwbjcl09n">
            Three patterns this month already cost you more than this entire treasury.
          </h2>
          <div className="mt-5 space-y-4 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-23" data-mp="27l6dyznbsi3g">
            <p data-id="element-24" data-mp="34ante6c41iic">
              Let&rsquo;s be honest for a second. If you&rsquo;ve bought even three patterns this
              month, you&rsquo;ve already spent more than the cost of this entire treasury.
            </p>
            <p data-id="element-25" data-mp="2v8emdqg1w79p">
              You are literally throwing money away on single PDFs that don&rsquo;t even give you the
              right to sell what you make. You&rsquo;re working for the designers, instead of the
              designers working for you.
            </p>
            <p className="font-bold text-ink" data-id="element-26" data-mp="1ev6h9o2zabbo">Does that sound like a smart business move to you?</p>
          </div>
        </Reveal>

        {/* 3D receipt */}
        <Reveal delay={0.12} className="perspective-stage" data-id="element-27" data-mp="1gasf9a995sri">
          <div className="mx-auto w-full max-w-sm rounded-2xl border border-hairline bg-cream p-6 shadow-lift" style={{
          transform: 'rotateY(-7deg) rotateX(3deg)'
        }} data-id="element-28" data-mp="1laeu1o4qbh2f">
            <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-ink-faint" data-id="element-29" data-mp="1c9p2iwmi4cui">
              Your last 30 days
            </p>
            <div className="mt-4 space-y-0" data-id="element-30" data-mp="12ckcumtg5z8y">
              {receipt.map(row => <div key={row.id} className="flex items-center justify-between gap-3 border-b border-dashed border-hairline py-3 text-xs text-ink-soft sm:text-sm" data-id="element-31" data-mp="olfj21crg16j">
                  <span className="flex items-center gap-2" data-id="element-32" data-mp="empyu1xe64n4">
                    <PdfIcon className="h-4 w-4 shrink-0 text-ink-faint" data-id="element-33" data-mp="epchoxpqg6kn" />
                    {row.label}
                  </span>
                  <span className="font-mono font-bold text-ink" data-id="element-34" data-mp="arnubnqapl">${row.amount}.00</span>
                </div>)}
            </div>
            <div className="mt-4 flex items-center justify-between rounded-xl bg-crimson-tint px-4 py-3" data-id="element-35" data-mp="3r85dnud9qap1">
              <span className="text-[11px] font-extrabold uppercase tracking-wide text-crimson" data-id="element-36" data-mp="a0bf9sgk7czl">
                Spent on 3 PDFs
              </span>
              <span className="font-display text-2xl font-extrabold text-crimson" data-id="element-37" data-mp="iz59jc6f3r9z">${spent}.00</span>
            </div>
            <div className="mt-3 flex items-center justify-between rounded-xl bg-sage-tint px-4 py-3" data-id="element-38" data-mp="e13o4klirfvc">
              <span className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-sage-dark" data-id="element-39" data-mp="so6msulkvuk9">
                <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-40" data-mp="nqn9bwwpfltd" />
                Whole treasury
              </span>
              <span className="font-display text-2xl font-extrabold text-sage-dark" data-id="element-41" data-mp="11q64lp4f32o9">
                ${PRICE.today}.00
              </span>
            </div>
            <p className="mt-3 text-center text-[10.5px] font-semibold uppercase tracking-wide text-ink-faint" data-id="element-42" data-mp="2r7tjkryrha4o">
              Same money. 1,000+ patterns instead of 3.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}